import { Controller } from "@hotwired/stimulus";

// Light scaffolding for the etude show cockpit. Currently it just observes
// the toolbar to add a "scrolled" class when the user scrolls past the
// header — that's what triggers the elevation/blur on the sticky toolbar.
// Role switching itself happens through plain links so it survives full
// page reloads and Pundit checks; this controller stays presentational.
export default class extends Controller {
  static values = { currentRole: String };

  connect() {
    this._toolbar = this.element.querySelector(".esm_cockpit__toolbar");
    if (!this._toolbar) return;
    this._onScroll = this._handleScroll.bind(this);
    window.addEventListener("scroll", this._onScroll, { passive: true });
    this._handleScroll();
  }

  disconnect() {
    if (this._onScroll) window.removeEventListener("scroll", this._onScroll);
  }

  _handleScroll() {
    const scrolled = window.scrollY > 24;
    this._toolbar.classList.toggle("esm_cockpit__toolbar--scrolled", scrolled);
  }
}
